import base from './base.repository';
export default {
    ...base,
    authenticate(user, pass, companySlug, vigilanceAccess) {
        const payload = {
            user,
            pass,
            companySlug,
            vigilanceAccess
        };

        // axios.post('api/v1/authenticate', payload)
        // .then(response => this.success(response.data))
        // .catch(error => this.error(error));
        this.post('auth/login', payload);
        return this;
    },
    authenticateSupervisor(user, password){
        this.post('auth/supervisor', { user, password });
        return this;
    }
}